type OffhoursDisplay = 'online' | 'offline' | 'none';
type Availability = 'online' | 'offline' | 'hidden';

export const mapOffhoursDisplayToAvailability = (
  offhoursDisplay?: OffhoursDisplay | string,
): Availability => {
  switch (offhoursDisplay) {
    case 'online':
      return 'online';
    case 'offline':
      return 'offline';
    case 'none':
      return 'hidden';
    case undefined:
      return 'offline';
    default:
      throw new Error(`Unexpected offhoursDisplay value: ${offhoursDisplay}`);
  }
};
